/* jhipster-needle-add-reducer-import - JHipster will add reducer here */
import objective from 'app/entities/objective/objective.reducer';
import organization from 'app/entities/organization/organization.reducer';
import planPeriod from 'app/entities/plan-period/plan-period.reducer';
import project from 'app/entities/project/project.reducer';
import workGroup from 'app/entities/work-group/work-group.reducer';
import employee from 'app/entities/employee/employee.reducer';
import field from 'app/entities/field/field.reducer';
import kr from 'app/entities/kr/kr.reducer';
import krQualitative from 'app/entities/kr/kr-qualitative.reducer';
import krQuantitative from 'app/entities/kr/kr-quantitative.reducer';
import reportSchedule from 'app/entities/report-schedule/report-schedule.reducer';
import reportCompliance from 'app/entities/report-compliance/report-compliance.reducer';
import progressLog from 'app/entities/progress-log/progress-log.reducer';
import activities from 'app/entities/activities/activities.reducer';
import filters from 'app/entities/filters/filters.reducer';
import common from 'app/entities/common/common.reducer';
import contribution from 'app/entities/contribution/contribution.reducer';
import person from 'app/entities/person/person.reducer';
import checkIn from 'app/entities/checkIn/checkIn.reducer';
import categoryReport from 'app/entities/category-report/category-report.reducer';
import checkInDraft from 'app/entities/checkIn/checkIn-draft.reducer';
import comments from 'app/entities/comment/comment.reducer';
import approvalLevel from 'app/entities/approval-level/approval-level.reducer';
import evaluationLevel from 'app/entities/evaluation-level/evaluation-level.reducer';
import categoryApprove from 'app/entities/approval-level/view/modal/category-approve.reducer';
import categoryEvaluation from 'app/entities/evaluation-level/view/modal/category-evaluation.reducer';
import selfConfirmCompleteEvaluation from 'app/entities/evaluation-level/view/modal/confirm-complete/self/confirm-complete.reducer';
import checkConfirmCompleteEvaluation from 'app/entities/evaluation-level/view/modal/confirm-complete/check/confirm-complete.reducer';
import evaluateConfirmCompleteEvaluation from 'app/entities/evaluation-level/view/modal/confirm-complete/evaluate/confirm-complete.reducer';
import checkInYear from 'app/entities/checkIn/checkIn-year.reducer';
import draftPeriod from 'app/entities/draft-period/draft-period.reducer';
import projects from 'app/entities/projects/projects.reducer';
import yearPlanningWindow from 'app/entities/annual-plan-window/annual-plan-window.reducer';

const entitiesReducers = {
  organization,
  objective,
  planPeriod,
  project,
  workGroup,
  employee,
  field,
  kr,
  filters,
  krQualitative,
  krQuantitative,
  reportSchedule,
  reportCompliance,
  progressLog,
  activities,
  common,
  contribution,
  person,
  checkIn,
  categoryReport,
  checkInDraft,
  comments,
  approvalLevel,
  evaluationLevel,
  categoryApprove,
  categoryEvaluation,
  selfConfirmCompleteEvaluation,
  checkConfirmCompleteEvaluation,
  evaluateConfirmCompleteEvaluation,
  checkInYear,
  draftPeriod,
  projects,
  yearPlanningWindow,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
